import { FC } from "react"
import React,{useEffect, useState, useMemo } from "react";
import { useIntl } from "react-intl"
import { PageTitle } from "../../../smallnation/layout/core"
import { KTSVG } from "../../../smallnation/helpers"
import services from "../../modules/services/services"
import { Pagination } from "../../modules/utility/Pagination"
import moment from "moment";
//import { TablesWidget10, TablesWidget5,TablesWidget1, TablesWidget2,TablesWidget3,TablesWidget4,TablesWidget6,TablesWidget7,TablesWidget8,TablesWidget9,TablesWidget11,TablesWidget12,TablesWidget13  } from "../../../smallnation/partials/widgets"
//import { ProfileDirectoryInc } from "../../../smallnation/partials/widgets/tables/profileDirectoryInc"
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import $ from 'jquery';

const CreateProfile: FC = () => {
      const intl = useIntl()
     
      const [currentPage, setCurrentPage] = useState(1);
      const ITEMS_PER_PAGE = 10; // Per page show the data pagination
      const Pagesize=10;
      const red="red";
      const [totalItems, setTotalItems] = useState(0);
      const [totalpages, settotalPages] = useState(0);
      const [adminProfileList, setAdminProfileList] = useState([]);

      const [personalProfile, setPersonalProfile] = useState([]);
      const [educationExperience, setEducationExp] = useState([]);

      const handlePageChange2 = (offset,triggerevent) => {
        // alert(offset);
        getAdminProfilesList(ITEMS_PER_PAGE,offset,'','');
      };
      function getAdminProfilesList(ITEMS_PER_PAGE,pageNumber,sortBy,sortDir){   

            const requestObject={
         
              "status":"published",
              "pageNumber":pageNumber,
              "sortyBy":"updatedDate",
              "pageSize":ITEMS_PER_PAGE,
              "siteId":"2",
              "sortDir":"asc"
            }
         console.log(requestObject);
         var accessTokenIn=sessionStorage.getItem("adminAccToken");
        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json',
                   // 'Authorization': "Bearer "+accessTokenIn 
                    //'Authorization': accessTokenIn 
                  },
          body: JSON.stringify(requestObject)
        };
        
        services.getAdminProfileList(requestOptions).then((res) => 
        {
            console.log("#######################");
            if(res){
              console.log(JSON.stringify(res));
              setTotalItems(res.totalElements);         
              settotalPages(Math.ceil(res.totalElements / ITEMS_PER_PAGE));            
              setCurrentPage(pageNumber);
              setAdminProfileList(res.content);   
            }
              
        
        });



            
        }

      useEffect(() => 
      {         
        getAdminProfilesList(ITEMS_PER_PAGE,'1','','');       
        $('#personalProfileValidMsg').hide();
        $('#educationExpValidMsg').hide();

      },[]);
      type Props = {
        className: string
      }
      return (
        <>
          <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'Profile Registration'})}</PageTitle>
        
                    <div className="container">
                        <div className="row">
                        <div className="col-lg-6">
                              <div className="mb-10">
                                  <div className="d-flex flex-column ">
                                    <label className="required form-label">Profile Status</label>
                                    <small>This does not affected user from logged in</small>
                                  
                                </div>
                                <select className="form-select" aria-label="Select example">
                                <option>Open this select menu</option>
                                <option value="1">One</option>
                                <option value="2">Two</option>
                                <option value="3">Three</option>
                                </select>
                            </div>
                        </div>
                        </div>

                        <div className="row">
                        <div className="col-lg-6">
                              <div className="mb-10">
                                  <div className="d-flex flex-column ">
                                    <label className="required form-label">First Name</label>
                                   </div>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder=""
                                />
                            </div>
                        </div>

                        <div className="col-lg-6">
                              <div className="mb-10">
                                  <div className="d-flex flex-column ">
                                    <label className="required form-label">Last Name</label>
                                   </div>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder=""
                                />
                            </div>
                        </div>

                        <div className="col-lg-6">
                              <div className="mb-10">
                                  <div className="d-flex flex-column ">
                                    <label className="required form-label">Email</label>
                                    <small>Valid Email address for notification</small>
                                   </div>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder=""
                                />
                            </div>
                        </div>

                        <div className="col-lg-6">
                              <div className="mb-10">
                                  <div className="d-flex flex-column ">
                                    <label className="required form-label">Phone</label>
                                    <small>xxx-xxx-xxxx</small>
                                   </div>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder=""
                                />
                            </div>
                        </div>

                        <div className="col-lg-6">
                              <div className="mb-10">
                                  <div className="d-flex flex-column ">
                                    <label className="required form-label">Personal Profile</label>
                                    <small>Max 500 Characters</small>
                                   </div>
                                   <CKEditor
                            editor={ ClassicEditor }
                            config={{
                              removePlugins: ["EasyImage","ImageUpload","MediaEmbed"]
                            }}
                            id="personalProfileId"                            
                            onReady={ editor => {
                                // You can store the "editor" and use when it is needed.
                                console.log( 'Editor is ready to use!', editor );
                                //editor.setData(profileDescription);
                                //editor.setData(profileDescription);
                                
                            } }
                            onChange={ ( event, editor ) => {
                                const data = editor.getData();
                                setPersonalProfile(data);
                                console.log( { event, editor, data } );
                            } }
                            onBlur={ ( event, editor ) => {
                                console.log( 'Blur.', editor );
                            } }
                            onFocus={ ( event, editor ) => {
                                console.log( 'Focus.', editor );
                            } }
                        />
                        <div id="personalProfileValidMsg" style={{color:red}} className="error">This field is required.</div>
                            </div>
                        </div>

                        <div className="col-lg-6">
                              <div className="mb-10">
                                  <div className="d-flex flex-column ">
                                    <label className="required form-label">Education/Exeperience</label>
                                    <small>Max 500 Characters</small>
                                   </div>
                                   <CKEditor
                            editor={ ClassicEditor }
                            config={{
                              removePlugins: ["EasyImage","ImageUpload","MediaEmbed"]
                            }}
                            id="educatioExpId"                            
                            onReady={ editor => {
                                // You can store the "editor" and use when it is needed.
                                console.log( 'Editor is ready to use!', editor );
                                //editor.setData(profileDescription);
                                //editor.setData(profileDescription);
                                
                            } }
                            onChange={ ( event, editor ) => {
                                const data = editor.getData();
                                setEducationExp(data);
                                console.log( { event, editor, data } );
                            } }
                            onBlur={ ( event, editor ) => {
                                console.log( 'Blur.', editor );
                            } }
                            onFocus={ ( event, editor ) => {
                                console.log( 'Focus.', editor );
                            } }
                        />
                        <div id="educationExpValidMsg" style={{color:red}} className="error">This field is required.</div>
                            </div>
                        </div>

                        <div className="col-lg-12 mb-10">
                              <div className="mb-10">
                                  <div className="d-flex flex-column ">
                                    <label className="required form-label">Categories of intrest</label>
                                  <small className="mb-3">Max Categories Freshman(5), sophomore(4), Juniors(3), Seniours(2)</small>
                                </div>
                               </div>
                               <div className="row">
                               <div className="col-md-6 mb-4">
                                <div className="form-check form-check-custom form-check-solid">
                                    <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault"/>
                                    <label className="form-check-label" htmlFor="flexCheckDefault">Agriculture </label>
                                </div>
                              </div>

                              <div className="col-md-6 mb-4">
                                <div className="form-check form-check-custom form-check-solid">
                                    <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault"/>
                                    <label className="form-check-label" htmlFor="flexCheckDefault">Banking, Finance & Insurance </label>
                                </div>
                              </div>

                              <div className="col-md-6 mb-4">
                                <div className="form-check form-check-custom form-check-solid">
                                    <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault"/>
                                    <label className="form-check-label" htmlFor="flexCheckDefault">Construction/Skilled Trades </label>
                                </div>
                              </div>

                              <div className="col-md-6 mb-4">
                                <div className="form-check form-check-custom form-check-solid">
                                    <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault"/>
                                    <label className="form-check-label" htmlFor="flexCheckDefault">Education </label>
                                </div>
                              </div>

                              <div className="col-md-6 mb-4">
                                <div className="form-check form-check-custom form-check-solid">
                                    <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault"/>
                                    <label className="form-check-label" htmlFor="flexCheckDefault">Government & Public Safety </label>
                                </div>
                              </div>

                              <div className="col-md-6 mb-4">
                                <div className="form-check form-check-custom form-check-solid">
                                    <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault"/>
                                    <label className="form-check-label" htmlFor="flexCheckDefault">Healthcare/Medical </label>
                                </div>
                              </div>

                              <div className="col-md-6 mb-4">
                                <div className="form-check form-check-custom form-check-solid">
                                    <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault"/>
                                    <label className="form-check-label" htmlFor="flexCheckDefault">Hospitality, Restaurant & Retail </label>
                                </div>
                              </div>

                              <div className="col-md-6 mb-4">
                                <div className="form-check form-check-custom form-check-solid">
                                    <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault"/>
                                    <label className="form-check-label" htmlFor="flexCheckDefault">IT </label>
                                </div>
                              </div>

                              <div className="col-md-6 mb-4">
                                <div className="form-check form-check-custom form-check-solid">
                                    <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault"/>
                                    <label className="form-check-label" htmlFor="flexCheckDefault">Manufacturing and Logistics </label>
                                </div>
                              </div>

                              <div className="col-md-6 mb-4">
                                <div className="form-check form-check-custom form-check-solid">
                                    <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault"/>
                                    <label className="form-check-label" htmlFor="flexCheckDefault">Non-Profit </label>
                                </div>
                              </div>

                              <div className="col-md-6 mb-4">
                                <div className="form-check form-check-custom form-check-solid">
                                    <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault"/>
                                    <label className="form-check-label" htmlFor="flexCheckDefault">Professional Services </label>
                                </div>
                              </div>

                              <div className="col-md-6 mb-4">
                                <div className="form-check form-check-custom form-check-solid">
                                    <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault"/>
                                    <label className="form-check-label" htmlFor="flexCheckDefault">Real Estate/Property Management </label>
                                </div>
                              </div>

                              <div className="col-md-6 mb-4">
                                <div className="form-check form-check-custom form-check-solid">
                                    <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault"/>
                                    <label className="form-check-label" htmlFor="flexCheckDefault">Sales and Marketing </label>
                                </div>
                              </div>

                              <div className="col-md-6 mb-4">
                                <div className="form-check form-check-custom form-check-solid">
                                    <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault"/>
                                    <label className="form-check-label" htmlFor="flexCheckDefault">Social work/Human Services </label>
                                </div>
                              </div>
                             
                               </div>
                        </div>


                        </div>
                        <div className="row">
                        <div className="col-lg-6">
                              <div className="mb-10">
                                  <div className="d-flex flex-column ">
                                    <label className="form-label">Profile Status</label>
                                    <small>This does not affected user from logged in</small>
                                  
                                </div>
                                <select className="form-select" aria-label="Select example">
                                <option>Open this select menu</option>
                                <option value="1">One</option>
                                <option value="2">Two</option>
                                <option value="3">Three</option>
                                </select>
                            </div>
                        </div>
                        </div>


                        <div className="row">
                        <div className="col-lg-6">
                              <div className="mb-10">
                                  <div className="d-flex flex-column ">
                                    <label className="required form-label">Upload a PDF Resume</label>
                                    <small>1 MB Max file type:PDF</small>
                                   </div>
                                   <h2>missing Upload Button</h2>
                            </div>
                        </div>
                        </div>
                             <button type="button" className="btn btn-primary mt-2" style={{maxWidth: "135px"}}> Post Resume </button>
                    </div>
      


          
        </>
      )
    }
export {CreateProfile}